<template>
  <div>

    <v-tooltip v-if="displayAsFab" right>
      <template v-slot:activator="{ on }">
        <v-btn
          fab
          color="blue lighten-2"
          v-on="on"
          @click.stop="showPreviewDialog = true; getPreview()"
        >
          <v-icon dark left>visibility</v-icon>
          <span>Prévisualiser CV</span>
        </v-btn>
      </template>
      <span>Prévisualiser le cv</span>
    </v-tooltip>

    <v-tooltip v-else right>
      <template v-slot:activator="{ on }">
        <v-btn
          block
          color="blue lighten-2"
          dark
          v-on="on"
          @click.stop="showPreviewDialog = true; getPreview()"
        >
          <v-icon dark left>visibility</v-icon>
          <span>Prévisualiser CV</span>
        </v-btn>
      </template>
      <span>Prévisualiser le cv</span>
    </v-tooltip>


    <v-dialog lazy v-model="showPreviewDialog" width="800px">

      <v-card>
        <v-layout
          v-if="!previewRequestError"
          row wrap
        >
          <v-flex xs12
            v-if="isLoading"
            text-xs-center
            class="pa-4"
          >
            <v-progress-circular
              :size="70"
              :width="7"
              color="purple"
              indeterminate
            ></v-progress-circular>
            <v-layout align-center justify-center>
              <v-card-title primary-title>
                <div>
                  <h3 class="headline">Prévisualisation de votre CV.</h3>
                  <span class="subheading"> Veuillez patientez... </span>
                </div>
              </v-card-title>
            </v-layout>
          </v-flex>
          <v-flex xs12 v-else class="pa-3">
            <v-layout justify-end>
              <v-btn icon @click="showPreviewDialog = false">
                <v-icon>close</v-icon>
              </v-btn>
            </v-layout>
            <v-img
              contain
              :src="image"
              :alt="modelObject.name"
            />
          </v-flex>
        </v-layout>
        <v-layout
          v-else
          row wrap
        >
          <v-flex xs12>
            <v-layout align-center justify-center>
              <v-card-title primary-title>
                <v-alert
                  :value="true"
                  type="warning"
                >
                  <h3 class="headline ">Une Erreur s'est produite.</h3>
                  Veuillez nous en excuser et ré-essayer ultérieurement.
                </v-alert>
              </v-card-title>
            </v-layout>
          </v-flex>
        </v-layout>

      </v-card>

    </v-dialog>

  </div>

</template>

<script>

 import session from '../api/session';
 // Import component
 // import Loading from 'vue-loading-overlay';
 // Import stylesheet
 // import 'vue-loading-overlay/dist/vue-loading.css';

 export default {
   props: {
     cvid: String,
     displayAsFab: Boolean,
   },
   data: function() {
     return {
       showPreviewDialog: false,
       modelObject: {},
       previewRequestError: false,
       sheet: false,
       api_url: '/api/cv/' + this.cvid,
       django_preview_url: '/api/cv/' + this.cvid + '/create_preview_img/',
       isLoading: false,
       fullPage: true,
       image: null,
       cv_name: null,
     }
   },
   methods: {
     // Async function : await la génération de l'image par Django,
     // Puis fetch les datas!!!
     getPreview() {
       console.log("+++++ Demande de preview emise +++++")
       // hack https://stackoverflow.com/questions/728616/disable-cache-for-some-images
       // permet d'évitez au browser d'utiliser son cache.
       // en effet : django_cleanup ne maintient que 2 versions du nom de l'image :
       // Voici un exemple de nommage des images de preview lors de 3 générations de preview:
       // ex :  preview-img/preview-img-2857fdf8-cf47-453f-85bc-af5befcbd7d7.png
       // puis: preview-img/preview-img-2857fdf8-cf47-453f-85bc-af5befcbd7d7_DPQIirf.png
       // enuite : preview-img/preview-img-2857fdf8-cf47-453f-85bc-af5befcbd7d7.png
       // ==> PB : le browser a caché la 1ere version (preview-img/preview-img-2857fdf8-cf47-453f-85bc-af5befcbd7d7.png)
       // lors du 3eme preview, il va ressortir la 1ere version.... Bien qu'elle n'est plus rien à voir sur le serveur.
       // ==> SOLUTION : le hack est de joindre à la requete un nombre aléatoire afin de forcer le browser
       // à refetcher l'image.
       var randomNum = Math.random();
       // on l'intègre plus bas dans la code à la source de img :
       // image.src = `${response.data['image_pre']}?dummy=${randomNum}`;

       // reinitialisation de l'erreur. Sinon même si le pb est
       // réglé sur le backend, le composant reste sur l'erreur.
       this.pdfRequestError = false;
       this.isLoading = true;
       session.get(this.django_preview_url, {  timeout: 30000,
       }, )
              .then((response) => {
                this.cv_name = response.data['cv_name'];
                var img_height = response.data['height'];
                // permet d'accéder à this dans la fonction a venir (pour accéder à this.showPdfDialog)
                // https://stackoverflow.com/questions/36176073/what-is-vue-way-to-access-to-data-from-methods
                var vm = this;

                console.log(response);
                var image = new Image();
                image.crossOrigin = "anonymous";

                image.addEventListener('load', function() {

                  var scissors = new Image();
                  scissors.addEventListener('load', function() {
                    // canvas principale dans lequel on collera les
                    // différente pages contenues dans des canvas.
                    var canvas = document.createElement("canvas");

                    // taille du canvas principal
                    canvas.width = 1024;

                    // Le offset sert à gérer le png des scissors.
                    // il faut ajouter cet espace à la dimension du canvas principal autant
                    // de fois que les scissors apparaissent (si nb page > 1)
                    var offsetValue = 110;
                    var heightWithOffset = img_height + Math.floor(2000/1410)*offsetValue;
                    canvas.height = heightWithOffset;
                    var canvas_ctx = canvas.getContext('2d');

                    for (var i = 0; i <=  Math.floor(img_height/1410); i++) {
                      //! This is all just html2canvas stuff
                      /*
                         NOTE A PROPOS DES DIMENSIONS :
                         Normalement 1024x1448.5 (format A4), mais pour corriger
                         l'effet PDF, on le positionne à 1410
                      */
                      console.log('--- iter ' + i + ' ---');
                      var srcImg  = image;
                      var sX      = 0;
                      var sY      = 1410*i; // start 1410 pixels down for every new page
                      var sWidth  = 1024;
                      var sHeight = 1410;
                      var dX      = 0;
                      var dY      = 0;
                      var dWidth  = 1024;
                      var dHeight = 1410;

                      var onePageCanvas = document.createElement("canvas");
                      onePageCanvas.width = 1024;
                      onePageCanvas.height = 1410;
                      var ctx = onePageCanvas.getContext('2d');
                      // details on this usage of this function:
                      // https://developer.mozilla.org/en-US/docs/Web/API/Canvas_API/Tutorial/Using_images#Slicing
                      ctx.drawImage(srcImg,sX,sY,sWidth,sHeight,dX,dY,dWidth,dHeight);

                      // document.body.appendChild(canvas);
                      // var canvasDataURL = onePageCanvas.toDataURL("image/png", 1.0);

                      var width         = onePageCanvas.width;
                      var height        = onePageCanvas.clientHeight;
                      console.log('canvas width : ' + width);
                      console.log('canvas height : ' + height);

                      var offset = 0;

                      if (i > 0) {
                        console.log("LES scissors")
                        canvas_ctx.drawImage(scissors, 0, 1410*i+10);
                        offset = offsetValue;
                      }


                      //! now we add content to that page!
                      console.log("coordonnée haut : " + (1410*i+offset));
                      canvas_ctx.drawImage(onePageCanvas, 0, 1410*i+offset);

                    }


                    vm.image = canvas.toDataURL("image/png", 1.0);
                    vm.isLoading = false;
                  });
                  scissors.src = require('../assets/scissors_small_stripes.png');
                });
                image.src = `${response.data['image_pre']}?dummy=${randomNum}`;



              })
              .catch((err) => {
                this.isLoading = false;

                if (err.response) {
                  // The request was made and the server responded with a status code
                  // that falls out of the range of 2xx
                  console.log('======= getPreview error in response =======')
                  console.log(err.response.data);
                  console.log(err.response.status);
                  console.log(err.response.headers);
                } else if (err.request) {
                  // The request was made but no response was received
                  // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                  // http.ClientRequest in node.js
                  console.log('======= getPreview error in request =======')
                  console.log(err.request);
                } else {
                  // Something happened in setting up the request that triggered an Error
                  console.log('======= getPreview error in else =======')
                  console.log('Err', err.message);
                }
              })
     },
   },

 }


</script>
